( function( $ ) {
	$( document ).ready( function() {

		var $dropdownItem = $( '.dropdown-filters .dropdown-item' );
		var $dropdownToggle = $( '.dropdown-filters .dropdown-toggle' );
		var $inputCheckbox = $( '.dropdown-filters .input-checkbox' );
		var $dropdownLabel = $( '.dropdown-filters .dropdown-label' );
		var $checkAll = $( '.dropdown-filters .check-all' );
		var $hideFirst = $( '.dropdown-filters .hide-first' );
		var $selectToShow = $( '.dropdown-filters .select-to-show .dropdown-item' );

		$dropdownItem.on( 'click', function() {
			var dropdownText = $( this ).text();

			$( this ).parents( '.dropdown' ).find( $dropdownToggle ).html( dropdownText );
		} );

		$inputCheckbox.on( 'click', function() {
			var $eventOption = $( this );
			var $options = $( this ).parents( '.dropdown' ).find( '.input-checkbox' );
			var $checkAllOption = $options.filter( '.check-all' ).eq( 0 );
			var $selectedOptions = $options.filter( ':checked' );
			var dropdownText = '';

			if ( $eventOption.is( ':checked' ) ) {
				if ( $selectedOptions.length === $options.length - 1 ) {
					$checkAllOption.prop( 'checked', true );
					$selectedOptions = $options.filter( ':checked' );
				} else if ( !$eventOption.is( '.check-all' ) ) {
					$checkAllOption.prop( 'checked', false );
				}
			} else if ( !$eventOption.is( '.check-all' ) ) {
				$checkAllOption.prop( 'checked', false );
				$selectedOptions = $options.filter( ':checked' );
			}

			if ( $selectedOptions.length && $selectedOptions.length < $options.length - 1 && !$selectedOptions.filter( '.check-all' ).length ) {
				$selectedOptions.each( function( i ) {
					var $curOption = $( this );
					var optionText = $curOption.siblings( $dropdownLabel ).text();
	
					if ( i != $selectedOptions.length - 1 ) {
						dropdownText += optionText + ', ';
					} else {
						dropdownText += optionText;
					}
				} );
			} else {
				dropdownText = $options.filter( '.check-all' ).eq( 0 ).siblings( $dropdownLabel ).text();
			}

			$( this ).parents( '.dropdown' ).find( $dropdownToggle ).text( dropdownText );
		} );

		$checkAll.on( 'click', function() {
			$inputCheckbox.not( this ).prop( 'checked', this.checked );
		} );

		$selectToShow.on( 'click', function() {
			var showFilter = $( this ).data( 'showFilter' );

			if ( showFilter ) {
				$hideFirst.show();
			} else {
				$hideFirst.hide();
			}
		} );

	} );
} )( jQuery );